var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoursesIconDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "20px",
    viewBox: "0 0 30 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(-21.000000, -386.000000)",
    fill: "#303F47",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "courses-icon",
    transform: "translate(21.000000, 386.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.30334834,9.51253512 C0.618485972,9.65951269 0.101720103,10.2239102 0.0155394869,10.9190445 C-0.0706411295,11.6141789 0.292653449,12.2876835 0.920889479,12.597455 C0.378353705,14.1061624 0.16305001,15.7130424 0.289280114,17.3113568 L3.007846,17.3113568 C3.13415827,15.7130607 2.9189422,14.1061812 2.37649349,12.597455 C3.00472952,12.2876835 3.3680241,11.6141789 3.28184348,10.9190445 C3.19566287,10.2239102 2.678897,9.65951269 1.99403463,9.51253512 L1.99403463,7.17229271 L1.30334834,6.81107585 L1.30334834,9.51253512 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5348247,18.1215254 C23.2865858,17.7906108 23.7718436,17.0468091 23.7718436,16.2254388 L23.7718436,10.7259423 L15.0125339,14.3155771 L6.25322418,10.7336994 L6.25322418,16.2254388 C6.25322418,17.0468699 6.73863854,17.7906883 7.49050018,18.1215254 C12.2833941,20.2312009 17.7419307,20.2312009 22.5348247,18.1215254 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "29.9510336 6.3753748 15.0125339 12.2027877 0.0486058667 6.3753748 15.0125339 0.547942742"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoursesIconDark);
export default __webpack_public_path__ + "static/media/courses-icon-dark.c96f33eb0b4229ef0df249ee9c8f9c24.svg";
export { ForwardRef as ReactComponent };